var map = {
	"./app-icon.svg": 1684,
	"./caret-right-icon.svg": 1685,
	"./chrome-icon.webp": 1686,
	"./edge-icon.webp": 1687,
	"./firefox-icon.webp": 1688,
	"./opera-icon.webp": 1689,
	"./safari-icon.webp": 1690,
	"./unknown-icon.webp": 1691
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1683;